import { Controller } from "@hotwired/stimulus"
import { get }        from '@rails/request.js'
import TomSelect      from "tom-select"

// Connects to data-controller="ts--search"
export default class extends Controller {
  static targets = [ "search", "filter" ]
  static values = {
    url: String,
    option: Object
  }

  connect() {
    this.searchElement.setAttribute( "autocomplete", "random" );

    var config = {
      plugins: ['clear_button'],
      render: {
        option: this.render_option
      },
      valueField: 'value',
      loadThrottle: 400,
      maxItems: 1,
      searchField: [],
      load: (q, callback) => this.search(q, callback)
    }

    if (this.hasOptionValue) {
      config.options = [this.optionValue]
    }

    var ts = new TomSelect(this.searchElement, config)

    if (this.hasOptionValue) {
      ts.setValue(this.optionValue.value)
    }

  }

  async search(q, callback) {

    var query = { q: q }

    if (this.hasFilterTarget) {
      query['filter'] = this.filterTarget.value
    }

    const response = await get(this.urlValue, {
      query: query,
      responseKind: 'json'
    })

    if(response.ok) {
      const json = await response.json
      this.searchElement.tomselect.clearOptions()
      console.log(json)
      callback(json)
    } else {
      console.error(response)
      callback()
    }
  }

  render_option(data, escape) {
    if(data.sub)
      return `
      <div>
        <div class="text">${escape(data.text)}</div>
        <div class="sub">${escape(data.sub)}</div>
      </div>`
    else
      return `<div>${escape(data.text)}</div>`
  }

  get searchElement() {
    if (this.hasSearchTarget) {
      return this.searchTarget
    } else {
      return this.element
    }
  }

}

/* EXEMPLO
<div data-controller="ts--search" data-ts--search-url-value="<%= auto_complete_atividades_por_nome_path %>">

  <%= f.input :catalogo_id,
              label: 'Selecione o Catálogo',
              collection: Catalogo.to_select,
              input_html: {
                data: {
                  ts__search_target: 'filter',
                  controller: 'ts--select',
                }
              } %>

  <%= f.input :id,
              label: 'Selecione a Requisição',
              as: :select,
              collection: [],
              input_html: {
                data: {
                  ts__search_target: 'search'
                }
              } %>

</div>
*/
